import * as React from "react";
import { Text, HorizontalButtonGroup } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import { getAppointmentTypesSelectorType } from "../../../../../utils/v3/utils/get-appointment-types-selector-type.js";
import AgeGroupButton from "../../../../AgeGroupButton/v3/components/AgeGroupButton/AgeGroupButton.js";
import ToggleInfoBoxContainer from "../../../../ToggleInfoBox/v3/components/ToggleInfoBox/ToggleInfoBoxContainer.js";
const useGetAgeGroupsSelectorAndSelectedAgeGroup = (availableAgeGroups) => {
  const toggleType = getAppointmentTypesSelectorType(availableAgeGroups);
  const { getLabel } = useIntl();
  const [selectedAgeGroup, setSelectedAgeGroup] = React.useState(toggleType === "none" ? "ALL" : "ADULT");
  React.useEffect(() => {
    setSelectedAgeGroup(toggleType === "none" ? "ALL" : "ADULT");
  }, [toggleType]);
  const labels = React.useMemo(
    () => ({
      childrenAdultsToggleTitle: getLabel("appointments.component.childAppointmentToggle.title"),
      seniorsAdultsToggleTitle: getLabel("appointments.component.seniorAppointmentToggle.title"),
      ageGroupChildTitle: getLabel("appointments.component.ageGroup.child.title"),
      ageGroupAdultTitle: getLabel("appointments.component.ageGroup.adult.title"),
      ageGroupSeniorTitle: getLabel("appointments.component.ageGroup.senior.title"),
      ageGroupTitle: getLabel("appointments.component.ageGroup.title"),
      appointmentTypesLabel: getLabel("appointments.component.appointmentTypes.title")
    }),
    [getLabel]
  );
  return React.useMemo(() => {
    let AgeGroupSelector = null;
    switch (toggleType) {
      case "children-adults-seniors-button-group":
        AgeGroupSelector = () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Text, { className: "typography-heading typography-heading--subheading1 appointment-types__age-group-title" }, labels.ageGroupTitle), /* @__PURE__ */ React.createElement(
          HorizontalButtonGroup,
          {
            Button: AgeGroupButton,
            items: [
              {
                itemID: "child",
                text: labels.ageGroupChildTitle,
                isSelected: selectedAgeGroup === "CHILD",
                onClick: () => {
                  setSelectedAgeGroup("CHILD");
                }
              },
              {
                itemID: "adult",
                text: labels.ageGroupAdultTitle,
                isSelected: selectedAgeGroup === "ADULT",
                onClick: () => {
                  setSelectedAgeGroup("ADULT");
                }
              },
              {
                itemID: "senior",
                text: labels.ageGroupSeniorTitle,
                isSelected: selectedAgeGroup === "SENIOR",
                onClick: () => {
                  setSelectedAgeGroup("SENIOR");
                }
              }
            ]
          }
        )), /* @__PURE__ */ React.createElement(Text, { className: "typography-heading typography-heading--subheading1 appointment-types__list-title" }, labels.appointmentTypesLabel));
        break;
      case "children-adults-toggle":
        AgeGroupSelector = () => /* @__PURE__ */ React.createElement("div", { className: "children-adults-toggle" }, /* @__PURE__ */ React.createElement(
          ToggleInfoBoxContainer,
          {
            icon: "child-appointment",
            text: labels.childrenAdultsToggleTitle,
            checked: selectedAgeGroup === "CHILD",
            onChange: (isEnabled) => {
              setSelectedAgeGroup(isEnabled ? "CHILD" : "ADULT");
            },
            toggleId: "appointment-child-under-16",
            "data-t": "childAppointmentToggle"
          }
        ));
        break;
      case "seniors-adults-toggle":
        AgeGroupSelector = () => /* @__PURE__ */ React.createElement("div", { className: "seniors-adults-toggle" }, /* @__PURE__ */ React.createElement(
          ToggleInfoBoxContainer,
          {
            icon: "child-appointment",
            text: labels.seniorsAdultsToggleTitle,
            checked: selectedAgeGroup === "SENIOR",
            onChange: (isEnabled) => {
              setSelectedAgeGroup(isEnabled ? "SENIOR" : "ADULT");
            },
            toggleId: "appointment-senior",
            "data-t": "seniorAppointmentToggle"
          }
        ));
        break;
    }
    return { AgeGroupSelector, selectedAgeGroup };
  }, [
    toggleType,
    selectedAgeGroup,
    labels.ageGroupTitle,
    labels.ageGroupChildTitle,
    labels.ageGroupAdultTitle,
    labels.ageGroupSeniorTitle,
    labels.appointmentTypesLabel,
    labels.childrenAdultsToggleTitle,
    labels.seniorsAdultsToggleTitle
  ]);
};
export {
  useGetAgeGroupsSelectorAndSelectedAgeGroup as default
};
//# sourceMappingURL=useGetAgeGroupsSelectorAndSelectedAgeGroup.js.map
